"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Settings = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SettingsTitleTextBox = require("./SettingsTitleTextBox");
var _SettingsDescriptionTextBox = require("./SettingsDescriptionTextBox");
var _SettingsAudioInput = require("./SettingsAudioInput");
var _JoinComponent = require("../JoinComponent.styled");
var _metrics = require("@studio/metrics");
var _CameraPreview = require("../../CameraPreview");
var _FormLabel = require("../../FormLabel");
var _ReadinessCheckerAudioTest = require("../../ReadinessCheckerAudioTest");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _constants = require("../../../constants");
var _feature = require("@studio/feature.flags");
var _constants2 = require("@studio/constants");
var _VirtualBackgroundUpload = _interopRequireDefault(require("../VirtualBackgroundUpload/VirtualBackgroundUpload"));
var _SettingsVideoInput = require("./SettingsVideoInput");
var _chime = require("@studio/chime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var INITIALIZATION_STATE = {
  PENDING: 'pending',
  SUCCESS: 'success',
  FAILED: 'failed'
};

// audioOutput changes have been disabled due to WEBINAR-34617
var Settings = exports.Settings = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var user = _ref.user,
    selectedVideoInputId = _ref.selectedVideoInputId,
    selectedAudioInputId = _ref.selectedAudioInputId,
    selectedAudioOutputId = _ref.selectedAudioOutputId,
    meetingSession = _ref.meetingSession,
    onVideoInputChange = _ref.onVideoInputChange,
    onAudioInputChange = _ref.onAudioInputChange,
    onPresenterDescriptionChange = _ref.onPresenterDescriptionChange,
    isAudioPermissionDenied = _ref.isAudioPermissionDenied,
    isVideoPermissionDenied = _ref.isVideoPermissionDenied,
    footer = _ref.footer,
    _ref$presenterDescrip = _ref.presenterDescription,
    presenterDescription = _ref$presenterDescrip === void 0 ? '' : _ref$presenterDescrip,
    checkStatus = _ref.checkStatus,
    _ref$transformedVideo = _ref.transformedVideoInput,
    transformedVideoInput = _ref$transformedVideo === void 0 ? null : _ref$transformedVideo,
    onTransformedVideoInputChange = _ref.onTransformedVideoInputChange,
    virtualBackground = _ref.virtualBackground,
    userBackground = _ref.userBackground,
    setUserBackground = _ref.setUserBackground,
    uploadUserVirtualBackground = _ref.uploadUserVirtualBackground,
    deleteUserVirtualBackground = _ref.deleteUserVirtualBackground,
    resetUserVirtualBackground = _ref.resetUserVirtualBackground,
    setIsVideoChanging = _ref.setIsVideoChanging,
    setIsVideoDisconnected = _ref.setIsVideoDisconnected,
    onVideoReady = _ref.onVideoReady,
    handleFirstNameChange = _ref.handleFirstNameChange,
    handleLastNameChange = _ref.handleLastNameChange;
  var _useBackgroundFilterP = (0, _metrics.useBackgroundFilterPageActionsApi)(),
    startAttendeeBackgroundFilterChangeLatency = _useBackgroundFilterP.startAttendeeBackgroundFilterChangeLatency,
    endAttendeeBackgroundFilterChangeLatency = _useBackgroundFilterP.endAttendeeBackgroundFilterChangeLatency;
  var allowBackgroundSettings = (0, _feature.shouldHaveFeature)('studio.blurredBackgrounds');
  var presenterTitle = "".concat(user === null || user === void 0 ? void 0 : user.firstName, " ").concat(user === null || user === void 0 ? void 0 : user.lastName);
  var isVirtualBackgroundsEnabled = (0, _feature.shouldHaveFeature)('studio.virtualBackgrounds') && (user === null || user === void 0 ? void 0 : user._id);
  var backgroundUrl = virtualBackground === null || virtualBackground === void 0 ? void 0 : virtualBackground.imageURL;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isLoadingVirtualBackground = _useState2[0],
    setIsLoadingVirtualBackground = _useState2[1];
  var _useState3 = (0, _react.useState)(INITIALIZATION_STATE.PENDING),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    vbInitStatus = _useState4[0],
    setVbInitStatus = _useState4[1];
  (0, _react.useEffect)(function () {
    var shouldSkipInitialization = vbInitStatus !== INITIALIZATION_STATE.PENDING || !isVirtualBackgroundsEnabled && !allowBackgroundSettings;
    if (shouldSkipInitialization) return;
    var initializeFilter = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (0, _chime.initializeBackgroundFilter)();
            case 3:
              setVbInitStatus(INITIALIZATION_STATE.SUCCESS);
              _context.next = 10;
              break;
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              console.warn('Unable to initialize background filter', _context.t0);
              setVbInitStatus(INITIALIZATION_STATE.FAILED);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 6]]);
      }));
      return function initializeFilter() {
        return _ref2.apply(this, arguments);
      };
    }();
    initializeFilter();
  }, [vbInitStatus, isVirtualBackgroundsEnabled, allowBackgroundSettings]);

  // Holds the selected background state during a background change process
  var _useState5 = (0, _react.useState)(null),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    backgroundSelection = _useState6[0],
    setBackgroundSelection = _useState6[1];
  (0, _react.useEffect)(function () {
    if (userBackground === _constants2.BACKGROUND_OPTIONS.CUSTOM) {
      handleBackgroundOptionChange(_constants2.BACKGROUND_OPTIONS.CUSTOM, true);
    }
  }, [backgroundUrl]);
  (0, _react.useEffect)(function () {
    if (userBackground !== _constants2.BACKGROUND_OPTIONS.NONE && transformedVideoInput) {
      onVideoInputChange(transformedVideoInput);
    } else if (selectedVideoInputId) {
      onVideoInputChange(selectedVideoInputId);
    }
  }, [userBackground, selectedVideoInputId, transformedVideoInput, onVideoInputChange]);
  var handleBackgroundOptionChange = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(option) {
      var hasCustomImage,
        videoInput,
        _args2 = arguments;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            hasCustomImage = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
            if (!(!hasCustomImage && (isLoadingVirtualBackground || option === userBackground))) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return");
          case 3:
            setIsLoadingVirtualBackground(true);
            setBackgroundSelection(option);
            _context2.prev = 5;
            startAttendeeBackgroundFilterChangeLatency({
              filterTypeBefore: userBackground,
              filterTypeAfter: option
            });
            _context2.next = 9;
            return (0, _chime.getVideoInput)(option, transformedVideoInput, selectedVideoInputId, onTransformedVideoInputChange, option === _constants2.BACKGROUND_OPTIONS.CUSTOM ? backgroundUrl : '');
          case 9:
            videoInput = _context2.sent;
            onVideoInputChange(videoInput);
            setUserBackground(option);
            endAttendeeBackgroundFilterChangeLatency();
            _context2.next = 19;
            break;
          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](5);
            console.error('Error changing background option', _context2.t0);
            endAttendeeBackgroundFilterChangeLatency({
              error: "Error changing background option : ".concat(_context2.t0.message)
            });
          case 19:
            _context2.prev = 19;
            setIsLoadingVirtualBackground(false);
            setBackgroundSelection(null);
            return _context2.finish(19);
          case 23:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[5, 15, 19, 23]]);
    }));
    return function handleBackgroundOptionChange(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var vbInitFailed = vbInitStatus === INITIALIZATION_STATE.FAILED;
  var vbInitSuccess = vbInitStatus === INITIALIZATION_STATE.SUCCESS;
  var disableInput = isAudioPermissionDenied;
  var checkInProgress = checkStatus === _constants.joinPageStatus.IN_PROGRESS;
  var showBlurredBackgroundSwitch = !isVirtualBackgroundsEnabled && allowBackgroundSettings && vbInitSuccess;
  var subtitle = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Choose your setup and check your devices to continue.");
  var body = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCameraPreviewWrapper, null, /*#__PURE__*/_react["default"].createElement(_CameraPreview.CameraPreview, {
    presenterTitle: presenterTitle,
    presenterDescription: presenterDescription,
    videoInputDevice: userBackground !== _constants2.BACKGROUND_OPTIONS.NONE ? transformedVideoInput : selectedVideoInputId,
    meetingSession: meetingSession,
    browserBlock: isVideoPermissionDenied,
    onVideoReady: onVideoReady
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement(_SettingsTitleTextBox.SettingsTitleTextBox, {
    user: user,
    isDisabled: disableInput,
    handleFirstNameChange: handleFirstNameChange,
    handleLastNameChange: handleLastNameChange
  })), /*#__PURE__*/_react["default"].createElement(_SettingsDescriptionTextBox.SettingsDescriptionTextBox, {
    presenterDescription: presenterDescription,
    handlePresenterDescriptionChange: onPresenterDescriptionChange,
    isDisabled: disableInput
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "pb-4"
  }, /*#__PURE__*/_react["default"].createElement(_SettingsVideoInput.SettingsVideoInput, {
    meetingSession: meetingSession,
    showBlurredBackgroundSwitch: showBlurredBackgroundSwitch,
    userBackground: userBackground,
    onVideoInputChange: onVideoInputChange,
    setUserBackground: setUserBackground,
    transformedVideoInput: transformedVideoInput,
    selectedVideoInputId: selectedVideoInputId,
    onTransformedVideoInputChange: onTransformedVideoInputChange,
    isAudioPermissionDenied: isAudioPermissionDenied,
    backgroundUrl: backgroundUrl,
    setIsVideoChanging: setIsVideoChanging,
    setIsVideoDisconnected: setIsVideoDisconnected
  })), isVirtualBackgroundsEnabled && /*#__PURE__*/_react["default"].createElement("div", {
    className: "pb-4"
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FormLabel.FormLabel, {
    id: "virtualBackground",
    label: "Virtual Background",
    labelFor: "virtualBackground",
    useAs: "span"
  }), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledButtonGroup, null, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledButton, {
    "data-testid": userBackground === _constants2.BACKGROUND_OPTIONS.NONE ? 'none-background-selected' : 'none-background',
    type: "button",
    active: userBackground === _constants2.BACKGROUND_OPTIONS.NONE,
    onClick: function onClick() {
      return handleBackgroundOptionChange(_constants2.BACKGROUND_OPTIONS.NONE);
    },
    "aria-label": "No virtual background",
    "aria-disabled": !vbInitSuccess,
    "aria-describedby": vbInitFailed && 'virtual-background-disabled'
  }, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledText, null, "None")), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledButton, {
    "data-testid": userBackground === _constants2.BACKGROUND_OPTIONS.BLUR ? 'blur-background-selected' : 'blur-background',
    type: "button",
    active: userBackground === _constants2.BACKGROUND_OPTIONS.BLUR,
    isBlur: true,
    onClick: function onClick() {
      return handleBackgroundOptionChange(_constants2.BACKGROUND_OPTIONS.BLUR);
    },
    "aria-disabled": backgroundSelection === _constants2.BACKGROUND_OPTIONS.BLUR || !vbInitSuccess,
    "aria-label": "Blur background",
    "aria-describedby": vbInitFailed && 'virtual-background-disabled'
  }, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledText, null, "Blur")), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledButton, {
    "data-testid": userBackground === _constants2.BACKGROUND_OPTIONS.CUSTOM ? 'custom-background-selected' : 'custom-background',
    type: "button",
    active: userBackground === _constants2.BACKGROUND_OPTIONS.CUSTOM,
    onClick: function onClick() {
      return handleBackgroundOptionChange(_constants2.BACKGROUND_OPTIONS.CUSTOM);
    },
    "aria-disabled": backgroundSelection === _constants2.BACKGROUND_OPTIONS.CUSTOM || !vbInitSuccess,
    "aria-describedby": vbInitFailed && 'virtual-background-disabled',
    "aria-label": "Custom background"
  }, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledText, null, "Custom"))), vbInitFailed && /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledVirtualBackgroundErrorText, {
    type: "error",
    text: _constants2.DEVICE_NOT_SUPPORTED_MESSAGE,
    id: "virtual-background-disabled"
  }), userBackground === _constants2.BACKGROUND_OPTIONS.CUSTOM && /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundUpload["default"], {
    uploadUserVirtualBackground: uploadUserVirtualBackground,
    virtualBackground: virtualBackground,
    deleteUserVirtualBackground: deleteUserVirtualBackground,
    resetUserVirtualBackground: resetUserVirtualBackground,
    isCustomBackgroundProcessing: !!backgroundSelection
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "pb-4"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-2"
  }, /*#__PURE__*/_react["default"].createElement(_FormLabel.FormLabel, {
    id: "test-audio-label",
    label: "Test audio",
    labelFor: "audioOutputTest",
    useAs: "span"
  }), /*#__PURE__*/_react["default"].createElement(_ReadinessCheckerAudioTest.ReadinessCheckerAudioTest, {
    audioDeviceId: selectedAudioOutputId,
    disabled: disableInput
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "pb-4"
  }, /*#__PURE__*/_react["default"].createElement(_SettingsAudioInput.SettingsAudioInput, {
    meetingSession: meetingSession,
    selectedAudioInputId: selectedAudioInputId,
    onAudioInputChange: onAudioInputChange,
    isDisabled: disableInput
  })))));
  if (checkInProgress) {
    body = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
    subtitle = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledIconSpinner, {
      icon: _freeSolidSvgIcons.faSpinner,
      className: "fa-spin"
    }), " Checking your system for best performance...");
  }
  return /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardBody, null, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardTitleContainer, null, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardTitle, {
    tag: "h4"
  }, "Settings")), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledSettingsComponentContent, null, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledSubtitle, null, subtitle), body), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardFooter, null, footer));
});
Settings.propTypes = {
  user: _propTypes["default"].object,
  selectedVideoInputId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  selectedAudioInputId: _propTypes["default"].string,
  selectedAudioOutputId: _propTypes["default"].string,
  meetingSession: _propTypes["default"].object,
  audioOutputDevices: _propTypes["default"].array,
  audioInputDevices: _propTypes["default"].array,
  onVideoInputChange: _propTypes["default"].func,
  onAudioInputChange: _propTypes["default"].func,
  onAudioOutputChange: _propTypes["default"].func,
  onPresenterTitleChange: _propTypes["default"].func,
  onPresenterDescriptionChange: _propTypes["default"].func,
  isAudioPermissionDenied: _propTypes["default"].bool,
  isVideoPermissionDenied: _propTypes["default"].bool,
  footer: _propTypes["default"].node,
  presenterDescription: _propTypes["default"].string,
  checkStatus: _propTypes["default"].string,
  transformedVideoInput: _propTypes["default"].object,
  onTransformedVideoInputChange: _propTypes["default"].func,
  virtualBackground: _propTypes["default"].object,
  userBackground: _propTypes["default"].oneOf([_constants2.BACKGROUND_OPTIONS.NONE, _constants2.BACKGROUND_OPTIONS.BLUR, _constants2.BACKGROUND_OPTIONS.CUSTOM]),
  setUserBackground: _propTypes["default"].func,
  uploadUserVirtualBackground: _propTypes["default"].func,
  deleteUserVirtualBackground: _propTypes["default"].func,
  setIsVideoChanging: _propTypes["default"].func,
  setIsVideoDisconnected: _propTypes["default"].func,
  onVideoReady: _propTypes["default"].func,
  handleFirstNameChange: _propTypes["default"].func,
  handleLastNameChange: _propTypes["default"].func
};